/*
 * @file: merchant.js
 * @description: Reducers and actions
 * @author: navreet
 */

import * as TYPE from '../../actions/constants'

/******** Reducers ********/
const initialState = {
    list: [],
    total_users: 0,
    pageNumber: 0,
    nextPage: 0,
    selectedAdminId: null,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case TYPE.ADMIN_LIST:
            return {
                ...state,
                list: action.data,
                pageNumber: action.res.previousPage + 1,
                nextPage: action.res.nextPage,
                total_users: action.res.total,
            }
        case TYPE.UPDATE_SELECTED_ADMIN_ID:
            return { ...state, selectedAdminId: action.data }

        case TYPE.LOG_OUT:
            return { ...initialState }
        default:
            return state
    }
}
